/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:42 2018/11/13
 */
 import * as Vue from 'vue-tsx-support';
 import { Component } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import FrameContentBg from 'src/pages/layout/components/frameContentBg';
 import { createBEM, createNamespace } from 'src/util/bem';
 import MenuBtn from 'src/pages/layout/components/menuBtn';
 import './tendencyAnalyse.less';
 import QueryForm, { QueryFormVOI } from 'src/components/queryForm/queryForm';
 import ECharts from 'vue-echarts';
 import FrameSideBg from 'src/pages/layout/components/frameSideBg';
 import StationTree from 'src/components/stationTree/stationTree';
 import Tab from 'src/components/tab/tab';
 import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import DatePicker from 'src/types/iview/DatePicker';
 import DataViewApi from 'src/pages/dataManage/dataView/api/dataViewApi';
 import PublicApi, { PublicApiI } from 'src/util/publicApi';
 import TendencyAnalyseApi, { TendencyAnalyseDOI } from './api/tendencyAnalyseApi';
 import { Toast } from 'src/util/toast';
 import { DateTimeUtil } from 'src/util/dateTimeUtil';
 import StationSider from 'src/pages/stationDetail/component/stationSider';
 import EnumStationType from 'src/enums/enumStationType';
 let bem = createBEM('tendency-analyse');
 
 enum EnumType {
     MulStation = '1',
     SingleStation = '2',
 }
 @Component({
     name: 'tendency-analyse',
 })
 export default class TendencyAnalyse extends Vue.Component<any> {
     queryFrom: QueryFormVOI.DateItemType[] = [
         {
             component: CommonSelect,
             label: '数据类型',
             field: 'cn',
             width: 200,
             labelWidth: 60,
             props: { value: '', dataSource: [] },
         },
         {
             component: DatePicker,
             label: '时间',
             field: 'time',
             width: 340,
             labelWidth: 60,
             realField: ['start_time', 'end_time'],
             timeType: 'number',
             props: { value: DateTimeUtil.getDayInterval(), type: 'datetimerange', placeholder: '请选择时间' },
         },
     ];
     get option() {
         let t = this;
         let series: any[] = [];
         if (this.type === EnumType.MulStation) {
             series = this.stationData.map(i => {
                 return {
                     name: i.name,
                     type: 'line',
                     smooth: true,
                     lineStyle: { width: 3 },
                     data: i.data.map(i => ({
                         name: DateTimeUtil.formateDate(i.timestamp * 1000),
                         value: [DateTimeUtil.formateDate(i.timestamp * 1000), i.value],
                     })),
                 };
             });
         } else {
             series = this.divisorData.map(i => {
                 return {
                     name: i.name,
                     type: 'line',
                     smooth: true,
                     lineStyle: { width: 3 },
                     data: i.data.map(i => ({
                         name: DateTimeUtil.formateDate(i.timestamp * 1000),
                         value: [DateTimeUtil.formateDate(i.timestamp * 1000), i.value],
                     })),
                 };
             });
         }
         let start = 0;
 
         try {
             let data = this.divisorData[0].data;
             let range = data[data.length - 1].timestamp - data[0].timestamp;
             range = Math.abs(range);
             if (range - 24 * 60 * 60 > 0) {
                 start = ((range - 24 * 60 * 60) / range) * 100;
             }
         } catch (error) {}
         return {
             color: ['#f45904', '#02fb71', '#419fff', '#effb29', '#00c9db', '#facd89', '#f19ec2', '#9eadf7', '#e4007f', '#ff00ff'],
             title: {
                 text: '',
                 textStyle: {
                     fontSize: 22,
                     color: '#fff',
                 },
                 left: 20,
                 top: 15,
             },
             dataZoom: [
                 {
                     type: 'inside',
                     start: start,
                     end: 100,
                 },
                 {
                     start: start,
                     end: 100,
                     handleIcon:
                         'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                     handleSize: '80%',
                     handleStyle: {
                         color: '#419FFF',
                         shadowBlur: 3,
                         shadowColor: 'rgba(0, 0, 0, 0.6)',
                         shadowOffsetX: 2,
                         shadowOffsetY: 2,
                         borderColor: '#419FFF',
                     },
                     fillerColor: 'rgba(65,159,255,0.5)',
                     backgroundColor: 'rgba(65,159,255,0.3)',
                     borderColor: '#419FFF',
                     textStyle: {
                         color: '#fff',
                     },
                 },
             ],
             tooltip: {
                 trigger: 'axis',
                 formatter(params) {
                     return [
                         `<span>${params[0].data.name}</span>`,
                         ...params.map(i => {
                             let unit = t.divisors.find(divisor => {
                                 return t.type === EnumType.MulStation
                                     ? t.checkedDivisors[0] === divisor.key
                                     : i.seriesName === divisor.name;
                             })!.unit;
                             return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                                 i.color
                             };"></span>${i.seriesName}：${i.value[1]}${unit}`;
                         }),
                     ].join('<br/>');
                 },
             },
             legend: {
                 data: this.type === EnumType.MulStation ? this.stationData.map(i => i.name) : this.divisorData.map(i => i.name),
                 textStyle: {
                     fontSize: 16,
                     color: '#fff',
                 },
                 top: 15,
                 type: 'scroll',
                 pageIconColor: '#fff',
                 pageTextStyle: {
                     color: '#fff',
                 },
             },
             grid: {
                 left: '3%',
                 right: '4%',
                 bottom: '50',
                 containLabel: true,
             },
             xAxis: {
                 type: 'time',
                 boundaryGap: false,
                 axisLabel: {
                     color: '#C3EBFF',
                     fontSize: 16,
                 },
                 axisLine: {
                     lineStyle: {
                         color: '#1DA4FF',
                         width: 3,
                     },
                 },
                 splitLine: {
                     show: true,
                     lineStyle: {
                         color: '#1DA4FF',
                         width: 3,
                         opacity: 0.2,
                     },
                 },
             },
             yAxis: {
                 type: 'value',
                 axisLabel: {
                     color: '#02FB71',
                     fontSize: 16,
                 },
                 axisLine: {
                     lineStyle: {
                         color: '#1DA4FF',
                         width: 3,
                     },
                 },
                 splitLine: {
                     lineStyle: {
                         color: '#1DA4FF',
                         width: 3,
                         opacity: 0.2,
                     },
                 },
             },
             series: series,
         };
     }
     tabs: { name: string; value: string | number }[] = [
         { name: '多站点单因子', value: EnumType.MulStation },
         { name: '单站点多因子', value: EnumType.SingleStation },
     ];
     type: string = '';
     // 当前站点
     currentStation!: StationListDOI.RowDataI;
     // type=1 时 当前选中照顾你点的mn集合
     mns: string[] = [];
     // 因子列表
     divisors: PublicApiI.DivisorI[] = [];
     checkedDivisors: string[] = [];
     stationData: TendencyAnalyseDOI.QueryMutStationResultI[] = [];
     divisorData: TendencyAnalyseDOI.QuerySingleStationResultI[] = [];
     loading: boolean = false;
     
     get types() {
        return EnumStationType.findCode(this.$route.params.type).getId();
     }
 
     async typeChnage(type: string) {
         this.type = type;
         let station = await (this.$refs.stationTree as StationTree).getStations();
         this.clearCheckStation();
         if (this.type === EnumType.MulStation) {
             // @ts-ignore
             station[0].checked = true;
         } else {
             this.$store.commit('stationDetail/saveCurrentStation', station[0])
         }
         this.checkedDivisors = [this.divisors[0].key];
         this.mns = [station[0].mn];
         this.search();
     }
     clearCheckStation() {
         (this.$refs.stationTree as StationSider).clearCheckedNode();
     }
     singleChange(data: StationListDOI.RowDataI) {
         this.currentStation = data;
         this.search();
     }
     multipleChange(data: string[]) {
         this.mns = data;
         this.search();
     }
     async queryAllDataType() {
         let { data, code } = await DataViewApi.searchDataType();
         if (code === 0) {
             if (this.types != 2) {
                 this.queryFrom[0].props.dataSource = [...data.map(i => ({ name: i.data_name, id: i.cn }))];
                 this.queryFrom[0].props.initValue = data[0].cn;
                 this.queryFrom[0].props.value = data[0].cn;
             }else{
                 let test = []
                 data.forEach(i => {
                    if(i.cn == "2082")
                    {
                        test.push({ name: i.data_name, id: i.cn })
                    }
                 });
                 this.queryFrom[0].props.dataSource = test;
                 this.queryFrom[0].props.initValue = test[0].id;
                 this.queryFrom[0].props.value = test[0].id;
             }
         }
     }
     async queryAllComponent() {
        let { data, code } = await PublicApi.getAllComponent();
        if (code === 0) {
            this.divisors = data;
        }
     }
     async search() {
         this.loading = true;
         if (this.type === EnumType.SingleStation) {
             await this.querySingleStation();
         } else {
             await this.queryMulStation();
         }
         this.loading = false;
     }
     async mounted() {
         await Promise.all([this.queryAllDataType(), this.queryAllComponent()]);
         this.typeChnage(EnumType.MulStation);
     }
     async queryMulStation() {
         if (this.mns.length === 0) {
             return Toast.error('请选择站点！');
         }
         let params = (this.$refs.queryForm as QueryForm).getQueryObj();
         let { code, data } = await TendencyAnalyseApi.searchMutStation({
             ...params,
             mns: this.mns,
             component: this.checkedDivisors[0],
         });
         if (code === 0) {
             this.stationData = data;
         }
     }
     async querySingleStation() {
         if (this.checkedDivisors.length === 0) {
             return Toast.error('请选择因子！');
         }
         let params = (this.$refs.queryForm as QueryForm).getQueryObj();
         let { code, data } = await TendencyAnalyseApi.searchSingleStation({
             ...params,
             mn: this.mns[0],
             components: this.checkedDivisors,
         });
         if (code === 0) {
             this.divisorData = data;
         }
     }
 
     render(h) {
         return (
             <layout class={bem()}>
                 <sider hide-trigger width={372} class={createNamespace('pa6')}>
                     <StationSider
                         ref="stationTree"
                         showCheckBox={this.type === '1'}
                         mn={this.mns[0]}
                         value={this.mns[0]}
                         on-input={v => (this.mns = [v])}
                         on-click={this.singleChange.bind(this)}
                         on-check-change={this.multipleChange.bind(this)}
                     />
                     {/* <FrameSideBg style="height: 100%">
                         <div class={[createNamespace(['pa10']), bem('tree-wrapper')]}>
                             <StationTree
                                 class={createNamespace(['mt10', 'mb10'])}
                                 ref="stationTree"
                                 showCheckBox={this.type === '1'}
                                 value={this.mns[0]}
                                 on-input={v => (this.mns = [v])}
                                 on-click={this.singleChange.bind(this)}
                                 on-check-change={this.multipleChange.bind(this)}
                             />
                         </div>
                     </FrameSideBg> */}
                 </sider>
                 <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                     <MenuBtn class={createNamespace('mb10')}/>
                     <div style="display: flex;">
                         <Tab style="flex:1;" dataSource={this.tabs} value={this.type} on-input={this.typeChnage.bind(this)} />
                         <QueryForm
                             style="display: inline-block;"
                             dataSource={this.queryFrom}
                             ref="queryForm"
                             on-search={this.search.bind(this)}
                         />
                     </div>
                     <FrameContentBg loading={this.loading}>
                         <div class={bem('chart-wrapper')}>
                             <ECharts style="flex:1;width:100%" options={this.option} auto-resize={true} />
                             <checkbox-group
                                 v-if={this.type === EnumType.SingleStation}
                                 v-model={this.checkedDivisors}
                                 on-on-change={this.search.bind(this)}
                             >
                                 {this.divisors.map(i => {
                                     return <checkbox size="large" label={i.key}>{`${i.name}(${i.unit})`}</checkbox>;
                                 })}
                             </checkbox-group>
                             <radio-group
                                 v-else
                                 value={this.checkedDivisors[0]}
                                 on-input={v => (this.checkedDivisors = [v])}
                                 on-on-change={this.search.bind(this)}
                             >
                                 {this.divisors.map(i => {
                                     return <radio size="large" label={i.key}>{`${i.name}(${i.unit})`}</radio>;
                                 })}
                             </radio-group>
                         </div>
                     </FrameContentBg>
                 </i-content>
             </layout>
         );
     }
 }
 